module.exports = __webpack_public_path__ + "img/Amenities.cfb21e78.png";